import { Col, Row, Typography, Form, Input, Button, Alert } from "antd";
import React, { useState } from "react";
import resetPassword from "../../services/resetPassword.service";
import AuthStore from "../../stores/authStore";

let { Title } = Typography;

export const UserProfile = (props) => {
  const [form] = Form.useForm();
  const [ResetPasswordAlert, setResetPasswordAlert] = useState(null);

  const onClose = () => {
    setResetPasswordAlert(null);
  };

  const onFinish = async (values) => {
    if (values.password1 !== values.password2) {
      return alert(
        `The two passwords are different '${values.password1}:${values.password2}'`
      );
    }
    try {
      let response = await resetPassword(values.password1, values.password2);
      AuthStore.dispatch({ type: "AUTH/LOG_IN", payload: response });
      setResetPasswordAlert(
        <Alert
          message={`Password changed successfully to ${values.password1}`}
          type="success"
          closable
          onClose={onClose}
        />
      );
    } catch (error) {
      console.log("Error getting data:", error?.data);
      alert("Error resetting password in: " + error?.data?.message);
    }
  };
  return (
    <Row justify="center">
      <Col span={16}>
        <Row justify="center">
          <Title>Change your Admin Account Password</Title>
        </Row>
        <Form
          form={form}
          name="ResetPassword"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Password"
            name="password1"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
              {
                type: "string",
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                message:
                  "Password should be atleast 8 characters with atleast 1 uppercase, 1 lowercase and 1 numeric character",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Reenter Password"
            name="password2"
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
              {
                type: "string",
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                message:
                  "Password should be atleast 8 characters with atleast 1 uppercase, 1 lowercase and 1 numeric character",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Row justify="center">
            <Form.Item shouldUpdate={true}>
              {() => (
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    !form.isFieldsTouched(true) ||
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length
                  }
                >
                  Reset Password
                </Button>
              )}
            </Form.Item>
          </Row>
          {ResetPasswordAlert ? ResetPasswordAlert : <></>}
        </Form>
      </Col>
    </Row>
  );
};
